import { render, staticRenderFns } from "./OrdersListingTable.vue?vue&type=template&id=2835e908"
import script from "./OrdersListingTable.vue?vue&type=script&lang=ts"
export * from "./OrdersListingTable.vue?vue&type=script&lang=ts"
import style0 from "./OrdersListingTable.vue?vue&type=style&index=0&id=2835e908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports